import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface IIdentificationDetails {
  vat_id_num: string;
  company_name: string;
  vat_return_id: number;
  vat_return_version_id: number;
  vat_return_reference: number;
}

export interface IVatReturnPeriodDetails {
  vat_return_period: string;
  vat_return_submission_date: Date;
  start_date?: Date;
  end_date?: Date;
}

interface IData {
  vat_return_status_id: number;
  vat_return_state: string;
  identification_details: IIdentificationDetails;
  vat_return_period_details: IVatReturnPeriodDetails;
}

export const fetchVatReturnDetail = async (
  id: number
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vatreturn/section/${id}`
  );

  let _data: IData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface ICountryVatRate {
  vat_rate_id: number;
  vat_rate_type_id: number;
  vat_rate: number;
}

interface ICountry {
  country_id: number;
  country: string;
  vat_rate: Array<ICountryVatRate>;
}

interface ICountriesByDateInput {
  start_date: string;
  end_date: string;
  excludeCyprus: boolean;
  exclude?: Array<number>;
}
export const fetchCountriesWithVatRateByDate = async (
  payload: ICountriesByDateInput
): Promise<Types.ResponseOutput> => {
  const exclude =
    payload.exclude && payload.exclude?.length > 0 ? payload.exclude : [];
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country/vat-rate/date?start_date=${
      payload.start_date
    }&end_date=${payload.end_date}&exclude=${exclude.join(',')}&excludeCyprus=${
      payload.excludeCyprus
    }`
  );

  let _data: Array<ICountry> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface ICountriesByQuarterInput {
  quarter_id: number;
  year: number;
  excludeCyprus: boolean;
  exclude?: Array<number>;
}
export const fetchCountriesWithVatRateByQuarter = async (
  payload: ICountriesByQuarterInput
): Promise<Types.ResponseOutput> => {
  const exclude =
    payload.exclude && payload.exclude?.length > 0 ? payload.exclude : [];
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country/vat-rate/quarter?quarter_id=${
      payload.quarter_id
    }&year=${payload.year}&exclude=${exclude.join(',')}&excludeCyprus=${
      payload.excludeCyprus
    }`
  );

  let _data: Array<ICountry> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IFixedEstablishmentsInput {
  vat_return_id: number;
}

interface IFixedEstablishmentsOutput {
  fixed_establish_id: number;
  vat_id_num: string;
  id_type_id: number;
  country_id: number;
  country: string;
  start_date: Date;
  cessation_date: Date;
}
export const fetchFixedEstablishmentsByVatReturnId = async (
  payload: IFixedEstablishmentsInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vatreturn/fixedEstablishments/${payload.vat_return_id}`
  );

  let _data: Array<IFixedEstablishmentsOutput> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface SaveVatReturnInput {
  vat_return_id: number;
  payload: any;
}
export const temporarySaveVatReturn = async (
  payload: SaveVatReturnInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'put',
    `${Environment.API_BASE_URL}/api/vatreturn/${payload.vat_return_id}/save/temporary`,
    payload.payload
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const finalSaveVatReturn = async (
  payload: SaveVatReturnInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'put',
    `${Environment.API_BASE_URL}/api/vatreturn/${payload.vat_return_id}/save/final`,
    payload.payload
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const nilSaveVatReturn = async (
  payload: SaveVatReturnInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'put',
    `${Environment.API_BASE_URL}/api/vatreturn/${payload.vat_return_id}/save/nil`,
    payload.payload
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
